import { Reveal, Eyebrow } from "./Reveal";
import { FORMAT_FACTS, IMAGES } from "../data/content";

export const Season = () => (
    <section id="season" data-testid="season-section" className="border-y border-white/10 bg-[#070c18]/70">
        <div className="mx-auto grid max-w-[1500px] gap-14 px-5 sm:px-8 py-24 sm:py-36 lg:grid-cols-2 lg:gap-20">
            <div>
                <Reveal>
                    <Eyebrow>Season One</Eyebrow>
                    <h2 className="deck-heading font-display text-5xl sm:text-6xl leading-[1.05] tracking-[0.12em]">
                        EVERY SEASON,<br />A NEW <span>MYSTERY</span>
                    </h2>
                    <p className="mt-8 max-w-xl text-base leading-relaxed text-zinc-400">
                        Season One follows the murder that ignites St. Bellmore — and the investigation that turns
                        private grief into public spectacle. Each returning season opens a new mystery that tests the
                        characters' ambitions all over again.
                    </p>
                    <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400">
                        The setting is fresh genre territory: an{" "}
                        <span className="text-zinc-200">Australian gothic academia</span> of sun-bleached sandstone
                        campuses and coastal noir — rich with family, food, faith, language and community texture the
                        campus mystery rarely explores outside an Anglo-American frame.
                    </p>
                </Reveal>
                <Reveal delay={0.15} className="mt-12">
                    <div className="relative overflow-hidden border border-white/10">
                        <img
                            src={IMAGES.atmosphere1}
                            alt="The world of St. Bellmore — coastal noir atmosphere"
                            loading="lazy"
                            className="aspect-[16/9] w-full object-cover grayscale-[30%]"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#04060d]/80 to-transparent" />
                        <p className="absolute bottom-4 left-5 font-mono text-[10px] tracking-[0.3em] text-zinc-400">
                            ST. BELLMORE — THE TOWN AT THE CENTRE OF THE SAGA
                        </p>
                    </div>
                </Reveal>
            </div>

            <Reveal delay={0.1} className="lg:pt-16">
                <div data-testid="season-facts" className="border border-white/10 bg-[#0b1220]">
                    <p className="border-b border-white/10 px-7 py-5 font-mono text-[10px] tracking-[0.35em] text-[#d6c68e]">
                        PRODUCTION DOSSIER
                    </p>
                    {FORMAT_FACTS.map(([k, v]) => (
                        <div
                            key={k}
                            className="group flex flex-col gap-1 border-b border-white/5 px-7 py-5 transition-colors duration-300 last:border-b-0 hover:bg-white/[0.03] sm:flex-row sm:items-baseline sm:gap-6"
                        >
                            <span className="w-40 shrink-0 font-mono text-[10px] tracking-[0.25em] text-zinc-500 group-hover:text-[#d6c68e] transition-colors">
                                {k}
                            </span>
                            <span className="text-sm sm:text-[15px] text-zinc-200">{v}</span>
                        </div>
                    ))}
                </div>
            </Reveal>
        </div>
    </section>
);
